export default ({request}) => ({
  changeOrderProofingListApi(data = {}) {
    return request({
      url: '/factory/changeOrderProofing/list',
      method: 'post',
      data,
    })
  },
  changeOrderProofingDetailApi(data = {}) {
    return request({
      url: '/factory/changeOrderProofing/detail',
      method: 'post',
      data,
    })
  },
  changeOrderProofingDelApi(data = {}) {
    return request({
      url: '/factory/changeOrderProofing/del',
      method: 'post',
      data,
    })
  },
  changeOrderProofingAddSaveApi(data = {}) {
    return request({
      url: '/factory/changeOrderProofing/add/save',
      method: 'post',
      data,
    })
  },
  changeOrderProofingEditSaveApi(data = {}) {
    return request({
      url: '/factory/changeOrderProofing/edit/save',
      method: 'post',
      data,
    })
  },
  changeOrderProofingGoodsListApi(data = {}) {
    return request({
      url: '/factory/changeOrderProofingGoods/list',
      method: 'post',
      data,
    })
  },
  changeOrderProofingGoodsDelApi(data = {}) {
    return request({
      url: '/factory/changeOrderProofingGoods/del',
      method: 'post',
      data,
    })
  },
  changeOrderProofingGoodsSaveApi(data = {}) {
    return request({
      url: '/factory/changeOrderProofingGoods/save',
      method: 'post',
      data,
    })
  },
  changeOrderProofingGoodsEditApi(data = {}) {
    return request({
      url: '/factory/changeOrderProofingGoods/edit',
      method: 'post',
      data,
    })
  },
})
